<div class="nav">
  <nav class="navbar-nav mr-auto pr-title" id="navHeader">
    <ul class="navbar-left">
      <li class="nav-item">
        <div class="navbar nav_title" style="border: 0;">
          <a class="site_title"><span>OneID</span></a>
        </div>
      </li>
    </ul>
  </nav>
  <nav class="navbar-nav ml-auto ">
    <ul class="navbar-right">
      <!--li class="nav-item">
        <a href="#" class="mt-2">
          <img class="img-fluid rounded-circle" src="../../iam/mw/assets/img/profile.png">
        </a>
      </li-->
      <!--User Profile-->
      <li class="dropdown float-right nav-item rightactive show" id="user-dropdown">
        <a class="nav-link dropdown-toggle login-user mt-2" id="navbarDropdown" role="button" data-toggle="dropdown"
          aria-haspopup="true" aria-expanded="false" (click)="loaduser()" title="My Profile"
          style="padding:5px 0px 5px 5px">
          <!--img class="img-fluid rounded-circle mr-2" style="width:100%" src="../../mw/assets/img/profile.png" alt="My Profile"-->
          <img class="img-fluid rounded-circle mr-2" style="width:85%" src="{{imgdynamicurl}}/assets/img/profile.png"
            alt="My Profile">
        </a>
        <div class="dropdown-menu dropdown-menu-right alert myaccountpanel" dir="ltr"
          aria-labelledby="navbarDropdownalert">
          <!--style="right:0;left:40px!important;width:210px"-->
          <div class="notification-overlay" data-component="notification-overlay" aria-expanded="false" role="region">
            <div class="notification-title" style="border-bottom: none;font-size:12px">
              <span>{{firstname}}</span>
            </div>
            <div class="notification-title" style="font-weight:100;margin-top:-20px;font-size:12px">
              <span>{{useremail}}</span>
            </div>
            <div class="notification-title" >
              <a style="cursor: pointer; font-size:12px" href="https://oneid.dewa.gov.ae/ext/pwdreset/Identify?AdapterId=PwdAdapter" target="_blank">Account Recovery</a>
            </div>
            <div class="notification-title" (click)="LogOut();">
              <span style="cursor: pointer; font-size:12px" (click)="LogOut();">Log Out </span>
            </div>
            <!--div class="notification-overlay__content myaccountoverlay" data-accessibility-content="true">
              <ul class="notification-list-items">
                <li class="notification-list-item">{{useremail}}</li>
                <li class="notification-list-item" style="cursor: pointer;" (click)="LogOut();"> <i class="fa fa-sign-out"></i> Logout </li>
              </ul>
            </div-->
          </div>
        </div>
       
        <!-- <a  id="ar"  style="margin-right: -3px;cursor: pointer;padding: 19px 0px 5px 5px;"   (click)="changeLangage('ar')">Arabic</a>
        <a  id="en"  style="margin-right: -3px;cursor: pointer;padding: 19px 0px 5px 5px;display: none;"   (click)="changeLangage('en')">English</a>
         -->
      </li>
      <!--End-->
      <li>
        <a class="mt-3" style="display:none">
          <img class="mr-3 img-fluid" src="{{imgdynamicurl}}/assets/img/icon-bell.png">
        </a>
      </li>
      <li>
        <a class="mt-3" routerLink="/Terms" style="display:none">
          <img class="mr-3 img-fluid" src="{{imgdynamicurl}}/assets/img/icon-info.png">
        </a>
      </li>
      <!-- <li> <a class="site_title" style="margin-right: 30px;direction: rtl;"><span>ةيبرعلا</span></a></li> -->
      <!--li id="liSearch" style="display: block;"-->
      <li id="liSearch">
        <!--div class="ng-autocomplete">
          <ng-autocomplete
            [data]="allapps"
            [searchKeyword]="keyword"
            (selected)='selectEvent($event)'
            (inputChanged)='onChangeSearch($event)'
            (inputFocused)='onFocused($event)'
            [itemTemplate]="itemTemplate"
            placeholder="Search Application"
            [notFoundTemplate]="notFoundTemplate">                                 
          </ng-autocomplete>   

          <div class="itemclass">
          <ng-template #itemTemplate let-item>            
          <a class="itemclass" [innerHTML]="item.applnname" href="item.applnurl"></a>                  
          </ng-template>          
        </div>
          <ng-template #notFoundTemplate let-notFound>
          <div [innerHTML]="notFound"></div>
          </ng-template>
          </div-->


        <form class="form-inline  pr-3    form-search"
          style="margin-bottom: 0.75rem!important; margin-top: 0.75rem!important;border-right:1px solid rgba(255, 255, 255, 0.3)">
          <button class="border-0 bg-transparent" type="submit">
            <svg width="16px" height="16px" viewBox="0 0 16 16" class="bi bi-search" fill="#717173"
              xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd"
                d="M10.442 10.442a1 1 0 0 1 1.415 0l3.85 3.85a1 1 0 0 1-1.414 1.415l-3.85-3.85a1 1 0 0 1 0-1.415z" />
              <path fill-rule="evenodd"
                d="M6.5 12a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11zM13 6.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0z" />
            </svg>
          </button>
          <!--input class="form-control mr-sm-2 bg-light" type="search" id="searchControl" placeholder="Search"
            aria-label="Search" style="display:block"-->
          <div class="ng-autocomplete">
            <ng-autocomplete [data]="allapps" [searchKeyword]="keyword" (selected)='selectEvent($event)'
              (inputChanged)='onChangeSearch($event)' (inputFocused)='onFocused($event)' [itemTemplate]="itemTemplate"
              placeholder="Search all applications..."  [notFoundTemplate]="notFoundTemplate">
            </ng-autocomplete>

            <ng-template #itemTemplate let-item>
              
              <a     class="itemclass" [innerHTML]="item.applnname"></a>

              <!-- <a   *ngIf="active_language_code=='ar'"   class="itemclass" [innerHTML]="item.applnname_ar"></a>
            -->
            </ng-template>

            <ng-template #notFoundTemplate let-notFound>
              <div [innerHTML]="notFound"></div>
            </ng-template>
          </div>
        </form>

      </li>

    </ul>
  </nav>
</div>